export const maskString = (str:string, pattern:string) => {
    let i = 0;
    const padded = pattern.replace(/#/g, () => {
        if (str[i])
            return str[i++];
        return '';
    });
    return padded;
}

export const ucFirst = (value:string) => {
    // empezar todas las palabras con mayuscula incluso si hay un espacio en un nombre o apellido compuesto
    value.replace(/\b\w/g, val => val.toUpperCase())
    // creamos arreglo temporal
    const temp = value.split(' ')
    // Se asegura que solo la primer letra de cada palabra comience con mayúscula
    const result = temp.map(key => {
       return key.charAt(0).toUpperCase() + key.toLowerCase().slice(1)
    })
    return result.join(' ')
 }

 export const formatCurrency = (value: string | number): string => {
  // Si el valor está vacío o es null/undefined, retornar cadena vacía
  if (!value && value !== 0) return '';
  
  const stringValue = value.toString();
  
  // Si termina en punto decimal, permitir el input y no formatear aún
  if (stringValue.endsWith('.')) {
    // Verificar que la parte antes del punto sea un número válido
    const beforeDecimal = stringValue.slice(0, -1);
    if (beforeDecimal === '' || isNaN(parseFloat(beforeDecimal))) return '0';
    
    // Formatear la parte antes del punto y agregar el punto
    const numericValue = parseFloat(beforeDecimal);
    return numericValue.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }) + '.';
  }
  
  // Limpiar cualquier formato existente (comas, espacios)
  const cleanValue = stringValue.replace(/[,\s]/g, '');
  
  // Verificar si es un número válido
  const numericValue = parseFloat(cleanValue);
  if (isNaN(numericValue)) return '0';
  
  // Formatear con separadores de comas
  return numericValue.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};